export const environment = {
  env: 'production',
  KEYCLOAK: {
    URL: 'https://auth.silvernova.ai/',
    CLIENT_ID: 'frontend',
    REALM: 'deubner',
  },
  partner: 'deubner',
  allowPasswordReset: false,
  logoUrl: '/assets/Deuber_Silvernova Icon.png',
  apiUrl: 'https://api.silvernova.ai/',
  socketUrl: 'https://api.silvernova.ai/',
  INTERCOM_BASE_URL: 'https://support.silvernova.legal/intercom-new.html',
  GEOAPIFY_API_KEY: '',
  HUBSPOT_ACCOUNT_ID: '27037154',
  ADDIN_URL: 'https://word.app.silvernova.ai/',
  USERTOUR_TOKEN: '',
  onboardingVideoEmbedUrl: 'https://youtu.be/CWKK0kelRyc',
  demoCasesIndexUrl: 'https://downloads.silvernova.ai/demo-cases/index.json',
}